/**************************************************
 * Nombre:       Dona_Limpia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import Chart from "react-apexcharts";
import {theme} from "../../Tema";
import {Grid} from "@mui/system";


const Barra_Plan_Carrera = ({metas = [], valor = 0, ancho}) => {

    const obtenerMetas = (metas) => {

        const m = metas.map(meta => {
            return {
                name: meta.nombre,
                value: meta.valor,
                strokeWidth: 2,
                strokeLineCap: 'round',
                strokeColor: '#fff'
            }
        })

        return m


    }


    const options = {
        chart: {
            type: 'bar',
            sparkline: {
                enabled: true,
            },

        },

        plotOptions: {
            bar: {
                horizontal: true,
            }
        },
        colors: [theme.palette.primary.main, '#ffffff20'],
        dataLabels: {
            enabled: false
        },

    }




    const series = [
        {
            name: 'Puntos Directos Actuales',
            data: [
                {
                    x: '',
                    y: valor,
                    goals: obtenerMetas(metas),
                }

            ]
        }
    ]

    const optionsDef = {
        chart: {
            type: 'bar',
            sparkline: {
                enabled: true,
            },

        },

        plotOptions: {
            bar: {
                horizontal: true,
            }
        },
        colors: ['#ffffff60', '#ffffff20'],
        dataLabels: {
            enabled: false
        },
        tooltip: {
            enabled: false,
            show: false
        }

    }

    const seriesDef = [
        {
            name: 'Puntos Totales',
            data: [100],
        }
    ]


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                <Chart
                    options={options}
                    series={series}
                    type="bar"
                    width={ancho}
                    height={32}
                    style={{marginTop: 0, marginBottom: 0, color: "#000"}}
                />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -4, zIndex: 1}}>
                <Chart
                    options={optionsDef}
                    series={seriesDef}
                    type="bar"
                    width={ancho}
                    height={32}
                    style={{marginTop: 0, marginBottom: 0, color: "#000"}}
                />
            </Grid>



        </Grid>

    )

}
export default Barra_Plan_Carrera

// sparkline: {
//                 enabled: false,
//             },